import { SITE_VERSION } from "../version";

interface DownloadProps {
  senderUrl: string;
}

const v = SITE_VERSION;

const DOWNLOADS = {
  deb: `/downloads/pairbolt_${v}_amd64.deb`,
  linuxTar: `/downloads/pairbolt-linux-amd64-${v}.tar.gz`,
  windowsSetup: `/downloads/PairBolt-${v}-windows-amd64-setup.exe`,
  macArmZip: `/downloads/PairBolt-${v}-macos-arm64.zip`,
  macIntelZip: `/downloads/PairBolt-${v}-macos-amd64.zip`,
  macArmDmg: `/downloads/PairBolt-${v}-macos-arm64.dmg`,
  macIntelDmg: `/downloads/PairBolt-${v}-macos-amd64.dmg`,
  checksums: "/downloads/SHA256SUMS",
} as const;

export function Download({ senderUrl }: DownloadProps) {
  return (
    <section id="download" className="section">
      <div className="section-inner">
        <p className="section-label">Download</p>
        <h2>Free receiver for your machine</h2>
        <p className="section-lead">
          Install once, then receive large files directly and privately. The
          browser sender stays free too — no Terminal required.
        </p>
        <p className="release-version" aria-label={`Current release ${SITE_VERSION}`}>
          Current release <strong>v{SITE_VERSION}</strong>
          <span className="release-note"> · Turbo TCP</span>
        </p>
        <div className="download-panel">
          <a className="btn btn-primary" href={DOWNLOADS.macArmZip}>
            Mac (Apple Silicon)
          </a>
          <a className="btn btn-outline" href={DOWNLOADS.macIntelZip}>
            Mac (Intel)
          </a>
          <a className="btn btn-outline" href={DOWNLOADS.windowsSetup}>
            Windows installer
          </a>
          <a className="btn btn-outline" href={DOWNLOADS.deb}>
            Linux .deb
          </a>
          <a className="btn btn-outline" href={senderUrl}>
            Open web sender
          </a>
        </div>
        <div className="prose" style={{ marginTop: "2rem" }} id="download-desktop">
          <p>
            <strong>Mac:</strong> download the <strong>.app zip</strong>, open it
            in Finder, drag <strong>PairBolt.app</strong> to Applications.{" "}
            <strong>First launch:</strong> right-click PairBolt → Open → Open
            (or double-click <strong>Open PairBolt.command</strong> in the zip).
            The management UI opens in your browser. If macOS still blocks the app,
            use System Settings → Privacy &amp; Security → Open Anyway. Disk image
            (secondary): <a href={DOWNLOADS.macArmDmg}>Apple Silicon</a>,{" "}
            <a href={DOWNLOADS.macIntelDmg}>Intel</a>.
          </p>
          <p>
            <strong>Windows:</strong> run the{" "}
            <a href={DOWNLOADS.windowsSetup}>setup wizard</a>, then finish with
            “Open PairBolt”. SmartScreen may warn until Authenticode signing
            lands — choose More info → Run anyway.
          </p>
          <p>
            <strong>Linux:</strong> install the{" "}
            <a href={DOWNLOADS.deb}>amd64 .deb</a> or use the{" "}
            <a href={DOWNLOADS.linuxTar}>binary tarball</a>. Checksums:{" "}
            <a href={DOWNLOADS.checksums}>SHA256SUMS</a>.
          </p>
        </div>
      </div>
    </section>
  );
}
